/**
 * @prettier
 */

import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import styles from './styles.module.less';

const FlowOverlay = ({ children, hideOverlay, hideBack, overlayElement }) => {
  return (
    <div className={styles.box}>
      {children}
      {overlayElement && (
        <div className={styles.overlayBox}>
          <div className={styles.backLinkBox}>
            {!hideBack && (
              <Link role="button" onClick={hideOverlay} arrow arrowPosition="prefix">
                Back
              </Link>
            )}
          </div>
          {overlayElement}
        </div>
      )}
    </div>
  );
};

FlowOverlay.defaultProps = {
  overlayElement: null,
};

export default FlowOverlay;
